import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useRecurringPayable, RecurringPayable } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<RecurringPayable>
      useData={useRecurringPayable}
      config={{
        ...moduleConfig,
        getInitialFormData: getInitialFormData as () => Partial<RecurringPayable>,
        mapItemToFormData: mapItemToFormData as (item: RecurringPayable) => Partial<RecurringPayable>,
      }}
    />
  );
};

export default Form;
